import { PopularSearchesData, SearchOptionLinksObject, SearchApi } from 'types/SearchProvider'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getIsInitialLoadReady } from 'selectors/user/isInitialLoadReady'
import { getPagePath } from 'selectors/page'
import { filterPopularSearches } from './helpers/transformPopularSearches'
import { transformConstructorRecommendationsResults } from './helpers/transformConstructorRecommendationsResults'

type UsePopularSearchesParams = {
  searchService: SearchApi
  maxPopularSearches?: number
}

type GetPopularSearchesParams = {
  selectedCategory: string
}

const usePopularSearches = ({
  searchService,
  maxPopularSearches = 5,
}: UsePopularSearchesParams) => {
  const [popularSearches, setPopularSearches] = useState<ReadonlyArray<SearchOptionLinksObject>>([])
  const isInitialLoadReady = useSelector(getIsInitialLoadReady)
  const canLoadPopularSearches = isInitialLoadReady
  const urlPath = useSelector(getPagePath)
  const urlPathParamsArray = urlPath.split('/').filter(Boolean)
  const firstPathParam = urlPathParamsArray[0] || ''
  const selectedCategory = firstPathParam === 'prints' ? urlPathParamsArray[1] : firstPathParam

  const getPopularSearches = async ({ selectedCategory }: GetPopularSearchesParams) => {
    const popularSearchesResponse = await searchService.fetchSearchProviderRecommendations<
      PopularSearchesData
    >({
      podId: 'trending-searches',
      section: 'Search Suggestions',
      numResults: 100,
    })

    if (popularSearchesResponse.success) {
      const transformedPopularSearches = transformConstructorRecommendationsResults(
        popularSearchesResponse.payload.data.recommendations
      )

      const filteredPopularSearches = filterPopularSearches({
        selectedCategory,
        popularSearches: transformedPopularSearches,
        maxPopularSearches,
      })

      setPopularSearches(filteredPopularSearches)
      return
    }

    setPopularSearches([])
  }

  useEffect(() => {
    if (canLoadPopularSearches) {
      getPopularSearches({ selectedCategory })
    }
  }, [selectedCategory, canLoadPopularSearches])

  return { popularSearches, getPopularSearches, setPopularSearches }
}

export default usePopularSearches
